export default __webpack_public_path__ + "static/media/costco.c5e67c0d.png";